module.exports = __webpack_public_path__ + "img/a50a1f5.jpg";